import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Truck, User, Receipt, Wallet } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TabItem {
    to: string;
    icon: typeof LayoutDashboard;
    label: string;
}

const tabs: TabItem[] = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/deliveries', icon: Truck, label: 'Deliveries' },
    { to: '/receipts/new', icon: Receipt, label: 'Receipt' },
    { to: '/collections', icon: Wallet, label: 'Collections' },
    { to: '/profile', icon: User, label: 'Profile' },
];

export function BottomTabBar() {
    return (
        <nav className="bottom-tab-bar">
            <div className="flex items-center justify-around h-14">
                {tabs.map(({ to, icon: Icon, label }) => (
                    <NavLink
                        key={to}
                        to={to}
                        className={({ isActive }) =>
                            cn(
                                'flex flex-col items-center justify-center flex-1 h-full py-2 transition-colors',
                                isActive
                                    ? 'text-primary'
                                    : 'text-muted-foreground'
                            )
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <div
                                    className={cn(
                                        'flex items-center justify-center w-12 h-7 rounded-full transition-colors',
                                        isActive && 'bg-primary/10'
                                    )}
                                >
                                    <Icon
                                        className={cn(
                                            'h-5 w-5',
                                            isActive && 'text-primary'
                                        )}
                                        strokeWidth={isActive ? 2.5 : 2}
                                    />
                                </div>
                                <span
                                    className={cn(
                                        'text-[10px] mt-1 font-medium',
                                        isActive && 'text-primary'
                                    )}
                                >
                                    {label}
                                </span>
                            </>
                        )}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
